import React from "react";
import * as XLSX from "xlsx";
import { LdIcon } from "@emdgroup-liquid/liquid/dist/react";
import {
  DETAILS_KEY,
  PF_HEADERS,
  SUMMARY_HEADERS,
  SUMMARY_KEY,
} from "@src/constants";
import { ButtonStyleOffTargetDownload } from "./DownloadExcelOffTarget.style";
import { timestampForFileName } from "@src/utils/utils";
import { excelTopLink } from "@src/config";

interface DownloadExcelButtonProps {
  data: any[];
  summaryData: any[];
}

const DownloadExcelOffTarget: React.FC<DownloadExcelButtonProps> = ({
  data,
  summaryData,
}) => {
  const headersSummary = SUMMARY_HEADERS;
  const headers = PF_HEADERS;
  const downloadExcel = (data: any[]) => {
    const dataValueExcel = createUpdateData(data[0], false);
    const dataValueSummary = createUpdateData(summaryData[0], true);

    // Create a hyperlink cell for the very top row (A1)
    const hyperlinkText = excelTopLink.text;
    const hyperlinkUrl = excelTopLink.link_url;
    const topLinkRow: any[] = [
      {
        t: "s",
        v: hyperlinkText,
        l: { Target: hyperlinkUrl, Tooltip: "Click to open" },
      },
    ];

    const dataExcleWithHeaders: any[][] = [
      topLinkRow,
      headers,
      ...dataValueExcel,
    ];
    const workBook = XLSX.utils.book_new();
    const dataOffTargetSummary: any[][] = [
      topLinkRow,
      headersSummary,
      ...dataValueSummary,
    ];

    const workSheet1 = XLSX.utils.aoa_to_sheet(dataOffTargetSummary);
    const workSheet2 = XLSX.utils.aoa_to_sheet(dataExcleWithHeaders);

    XLSX.utils.book_append_sheet(workBook, workSheet1, "off-target-summary");
    XLSX.utils.book_append_sheet(workBook, workSheet2, "off-target-details");

    XLSX.writeFile(
      workBook,
      `base_editor_offtarget_${timestampForFileName()}.xlsx`
    );
  };
  return (
    <ButtonStyleOffTargetDownload
      onClick={() => downloadExcel(data)}
      size="sm"
      download
    >
      Download
      <LdIcon name="cloud-download" />
    </ButtonStyleOffTargetDownload>
  );
};

const createUpdateData = (data: any[], summaryFlag: boolean) => {
  const keysToCollect: string[] = summaryFlag ? SUMMARY_KEY : DETAILS_KEY;
  const dataForExcel: any[][] = data?.map((obj) =>
    keysToCollect.flatMap((key) => {
      return obj[key];
    })
  );
  return dataForExcel;
};

export { DownloadExcelOffTarget };
